export class Survey {
  public formId: string;
  public createdOn: Date;
  public isCompleted: boolean;
  public seatId: string;

  public static parse(data: any): Survey {
    if (!data) return null;

    let survey = new Survey();
    Object.assign(survey, data);

    return survey;
  }
}

export enum TeamSurveyStatus {
  Open = 'open',
  Closed = 'closed',
}
